import { TransactionType } from '@/types/transactionRequests';
import { create } from 'zustand';

type UseTransactionFormModalState = {
  open: boolean;
  bankAccountId: string;
  customerId: string;
  type: TransactionType;
  openTransactionFormModal: (data: {
    bankAccountId: string;
    customerId: string;
    type: TransactionType;
  }) => void;
  closeTransactionFormModal: () => void;
};

export const useTransactionFormModal = create<UseTransactionFormModalState>(
  set => {
    return {
      open: false,
      bankAccountId: '',
      customerId: '',
      type: 'transfer',
      openTransactionFormModal: data => {
        const { customerId, bankAccountId, type } = data;

        set({
          open: true,
          customerId,
          bankAccountId,
          type,
        });
      },
      closeTransactionFormModal: () => {
        set({ open: false, customerId: '' });
      },
    };
  },
);
